import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ResponseBase} from "../../data";
import {ControlParam, Event, MetricParam, Range} from "../../data/metricParam";

export interface MetricParamState {
    response: ResponseBase | null
    loading: boolean,
    error: ResponseBase | null,
    requestFinished: boolean,
    controlParamList: ControlParam[],
    selectedControlParam: ControlParam
    metricList: MetricParam[],
    eventList: Event[],
    rangeList: Range[]
}

const initialMetricParamState: MetricParamState = {
    response: null,
    loading: false,
    error: null,
    requestFinished: false,
    controlParamList: [],
    selectedControlParam: {} as ControlParam,
    metricList: [],
    eventList: [],
    rangeList: []
}

const metricParamSlice = createSlice({
    name: 'metricParam',
    initialState: initialMetricParamState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.loading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.loading = false;
            state.error = action.payload;
        },
        setRequestFinished(state, action: PayloadAction<boolean>) {
            state.requestFinished = action.payload;
            state.loading = false;
        },
        setControlParamList(state, action: PayloadAction<ControlParam[]>) {
            state.controlParamList = action.payload;
            state.loading = false;
        },
        setSelectedControlParam(state, action: PayloadAction<ControlParam>) {
            state.selectedControlParam = action.payload;
            state.loading = false;
        },
        setMetricList(state, action: PayloadAction<MetricParam[]>) {
            state.metricList = action.payload;
            state.loading = false;
        },
        setEventList(state, action: PayloadAction<Event[]>) {
            state.eventList = action.payload;
            state.loading = false;
        },
        setRangeList(state, action: PayloadAction<Range[]>) {
            state.rangeList = action.payload;
            state.loading = false;
        },
    }
});

export const metricParamActions = metricParamSlice.actions;
export default metricParamSlice;
